import { NotificationDefinition } from '../../types'
import { InvoiceTaxErrorHeader } from './InvoiceTaxErrorHeader'
import { InvoiceTaxErrorListItem } from './InvoiceTaxErrorListItem'
import { InvoiceTaxErrorPreview } from './InvoiceTaxErrorPreview'

export const invoiceTaxErrorDefinition: NotificationDefinition = {
  listItemContent: InvoiceTaxErrorListItem,
  previewHeaderContent: InvoiceTaxErrorHeader,
  previewContent: InvoiceTaxErrorPreview
}
